function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getProp(obj, path, defaultValue) {
  return path
    .split(".")
    .reduce((a, c) => (a && a[c] ? a[c] : defaultValue), obj);
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return "";
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class AddToCartButton {
  constructor(el) {
    this.states = {
      default: "add-to-cart-button_active",
      loading: "add-to-cart-button_loading",
      disabled: "add-to-cart-button_disabled",
      error: "add-to-cart-button_error",
    };

    this.el = el;
    this.el.classList.add(this.states.default);
  }

  setState(state) {
    const keys = Object.keys(this.states);
    if (keys.indexOf(state) > -1) {
      keys.forEach(key => {
        this.el.classList.remove(this.states[key]);
      });
      this.el.classList.add(this.states[state]);
    }
  }

  resetState() {
    const keys = Object.keys(this.states);
    keys.forEach(key => {
      this.el.classList.remove(this.states[key]);
    });
    this.el.classList.add(this.states.default);
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.quantityUpdateUnsubscriber = undefined;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class ProductPreviewForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.hideErrors = this.dataset.hideErrors === "true";
    this.addToCartButton = new AddToCartButton(this.submitButton);
    this.cartMini = window.miniCartInstance;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.addToCartButton.setState("loading");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status ) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.addToCartButton.setState("error");
          return;
        } else if (!this.cartMini) {
          this.addToCartButton.setState("success");
          window.miniCartInstance.refresh();

          setTimeout(() => {
            window.miniCartInstance.open();
            this.submitButton.removeAttribute("aria-disabled");
            this.addToCartButton.resetState();
          }, 500);

          return;
        }

        this.cartMini.refresh();
        this.addToCartButton.setState("success");
        setTimeout(() => {
          this.cartMini.open();
          this.submitButton.removeAttribute("aria-disabled");
          this.addToCartButton.resetState();
        }, 500);
      })
      .catch(e => {
        console.error(e);
        this.submitButton.setAttribute("aria-disabled", true);
        this.addToCartButton.setState("error");
      });
  }
}

customElements.define("product-preview-form", ProductPreviewForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    this.submitButton = document.getElementById(
      `product-form-${this.dataset.section}-submit`
    );
    this.addToCartButton = new AddToCartButton(this.submitButton);
    this.isOptionButton = false;

    this.addEventListener("click", e => this.handleInteraction(e, "click"));
    this.addEventListener("change", e => this.handleInteraction(e, "change"));
  }

  handleInteraction(event) {
    const isButtonInteraction = event.target.closest(".option-button");
    const isDropdownInteraction = event.target.tagName === "SELECT";

    if (isButtonInteraction) {
      this.handleClickButton(event);
    }

    if (isDropdownInteraction) {
      this.updateOptions();
    }

    this.onVariantAction();
  }

  onVariantAction() {
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.setSubmitButtonLoading();
    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  handleClickButton(e) {
    const clickedButton = e.target.closest(".option-button");
    const selectedLabel = document.querySelector(".selected-label");

    if (clickedButton) {
      const value = clickedButton.dataset.value;
      const optionName = clickedButton.dataset.option;

      selectedLabel.innerText = value;

      const allButtons = this.querySelectorAll(
        `.option-button[data-option="${optionName}"]`
      );
      allButtons.forEach(button => {
        button.setAttribute("aria-pressed", "false");
        button.classList.remove("selected");
      });

      clickedButton.setAttribute("aria-pressed", "true");
      clickedButton.classList.add("selected");

      const selectedButtons = clickedButton.closest(".selected-buttons");
      if (selectedButtons) {
        selectedButtons.dataset.value = value;
      }
    }

    this.updateOptions();
  }

  selectFirstButton() {
    const selectedWrappers = document.querySelectorAll(".selected-buttons");

    selectedWrappers.forEach(wrapper => {
      const parentEl = wrapper.closest(".product-form__input");
      const selectedLabel = parentEl.querySelector(".selected-label");
      const firstAvailableButton =
        parentEl.querySelectorAll(".option-button")[0];

      if (
        firstAvailableButton &&
        !firstAvailableButton.hasAttribute('[aria-pressed="true"]')
      ) {
        firstAvailableButton.setAttribute("aria-pressed", "true");
        firstAvailableButton.classList.add("selected");
        selectedLabel.innerText = firstAvailableButton.dataset.value;
        wrapper.dataset.value = firstAvailableButton.getAttribute("data-value");
      }

      parentEl.querySelectorAll(".option-button").forEach(button => {
        if (button !== firstAvailableButton) {
          button.setAttribute("aria-pressed", "false");
          button.classList.remove("selected");
        }
      });
    });

    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
  }

  setSubmitButtonLoading() {
    this.addToCartButton.setState("loading");
    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.setAttribute("disabled", "disabled");
  }

  handleClickButton(e) {
    const closestButton = e.target.closest(".option-button");
    const selectedLabel = document.querySelector(".selected-label");

    if (closestButton) {
      const value = closestButton.dataset.value;

      selectedLabel.innerText = value;

      const selectedButtons = closestButton.closest(".selected-buttons");
      selectedButtons.dataset.value = value;

      selectedButtons.querySelectorAll(".option-button").forEach(button => {
        button.classList.remove("selected");
        button.setAttribute("aria-pressed", "false");
      });

      closestButton.classList.add("selected");
      closestButton.setAttribute("aria-pressed", "true");

      this.updateOptions();
    }
  }

  updateOptions() {
    const buttonOptions = Array.from(
      this.querySelectorAll(".selected-buttons"),
      select => select.dataset.value
    );

    const dropdownOptions = Array.from(
      this.querySelectorAll("select"),
      select => select.value
    );

    this.options = [...dropdownOptions, ...buttonOptions];
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          if (!this.options) return;
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_image) return;

    const mediaGallery = document.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    if (!mediaGallery) return;

    const featuredImage = mediaGallery.querySelector("#main-product-image");
    const featuredImageZoom = mediaGallery.querySelector(
      "#main-product-image-zoom"
    );
    if (!featuredImage) return;

    if (getProp(this.currentVariant, "featured_image.src", undefined)) {
      // Update image
      featuredImage.removeAttribute("srcset");
      featuredImage.removeAttribute("sizes");
      featuredImage.src = this.currentVariant.featured_image.src;

      // Update image zoom
      if (featuredImageZoom) {
        featuredImageZoom.style.backgroundImage = `url(${this.currentVariant.featured_image.src})`;
      }

      // Send event for external scripts
      publish(
        "slide-media-id",
        `${this.dataset.section}-${this.currentVariant.featured_image.id}`
      );
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => {
      if (!this.querySelector(":checked")) return;

      this.querySelector(":checked").value === variant.option1;
    });
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      if (!option.querySelectorAll(".selected-buttons")) {
        const optionInputs = [
          ...option.querySelectorAll('input[type="radio"], option'),
        ];
        const previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked").value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            variant =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map(variantOption => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        // update price
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("hidden");

        // update button
        const destinationButton = this.submitButton;
        const sourceButton = html.getElementById(
          `product-form-${this.dataset.section}-submit`
        );

        if (sourceButton && destinationButton)
          destinationButton.innerHTML = sourceButton.innerHTML;

        if (sourceButton.hasAttribute("disabled")) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.setAttribute("disabled", "disabled");
        } else {
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.removeAttribute("disabled");
        }

        this.addToCartButton.setState("default");

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  setUnavailable() {
    const addButton = this.productForm.querySelector('[name="add"]');
    const addButtonText = this.productForm.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    // const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    // const sku = document.getElementById(`Sku-${this.dataset.section}`);
    // const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    // const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    // const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    // const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    this.addToCartButton.setState("default");
    this.submitButton.removeAttribute("aria-disabled");
    this.submitButton.removeAttribute("disabled");
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    // if (inventory) inventory.classList.add("hidden");
    // if (sku) sku.classList.add("hidden");
    // if (pricePerItem) pricePerItem.classList.add("hidden");
    // if (volumeNote) volumeNote.classList.add("hidden");
    // if (volumeTable) volumeTable.classList.add("hidden");
    // if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

document.addEventListener("DOMContentLoaded", () => {
  const variantSelectsElements = document.querySelectorAll("variant-selects");

  variantSelectsElements.forEach(variantSelect => {
    if (variantSelect instanceof VariantSelects) {
      variantSelect.selectFirstButton();
    }
  });

  const cartMiniCloseBtn = document.querySelector("[data-cart-mini-close]");
  const cartMiniSidebar = document.querySelector("[data-cart-mini-sidebar]");
  const cartMini = document.querySelector("[data-cart-mini");

  if (cartMiniCloseBtn) {
    cartMiniCloseBtn.addEventListener("click", () => {
      cartMini.classList.remove("cart-mini-open");
    });
  }

  document.addEventListener("click", e => {
    if (!cartMiniSidebar.contains(e.target)) {
      cartMini.classList.remove("cart-mini-open");
    }
  });

  Object.keys(localStorage).forEach(key => {
    if (key.includes('cart_error')) {
      localStorage.removeItem(key);
    }
  });
});

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        radio => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class QuantityCartInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach(button =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === "plus") {
      this.input.stepUp();
    }

    if (event.currentTarget.name === "minus") {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-cart-input", QuantityCartInput);

class QuantityCartMiniInput extends QuantityCartInput {
  constructor() {
    super();
    this.cartMini = window.miniCartInstance;
    this.cartItemParent = this.closest('.cart-mini-item-details-footer');
    this.cartMiniContainer = this.closest('[data-cart-mini]');
    this.cartItemEl = this.closest('.cart-mini-item');
    this.cartItemKey = this.cartItemEl.getAttribute('data-cart-item-key');
    this.productTitle = this.cartItemEl.getAttribute('data-cart-item-title');
    this.variantTitle = this.cartItemEl.getAttribute('data-cart-item-variant-title');
    this.buttonPlus = this.querySelector('button[name="plus"]');
    this.buttonMinus = this.querySelector('button[name="minus"]');
    this.errorTag = this.closest('.cart-mini-item').querySelector('.cart_response_error_message');
    this.submitButton = document.querySelector('.add-to-cart-button[type="submit"]');
    this.addToCartButton = this.submitButton ? new AddToCartButton(this.submitButton) : null;
    this.debouncedHandleQuantityChange = debounce(this._handleQuantityChange.bind(this), 300);

    this.init();
  }

  init() {
    this.restoreErrorFromStorage();

    if (this.errorCartItemKey === this.cartItemKey) {
      this.buttonPlus.setAttribute('aria-disabled', true);
    }

    this.addEventListener('change', (event) => this.debouncedHandleQuantityChange(event));

  }

  async _handleQuantityChange(event) {
    this.clearError();
    const requestedQuantity = parseInt(event.target.value, 10);

    this.buttonPlus.setAttribute('aria-disabled', true);
    this.buttonPlus.disabled = true;
    this.buttonMinus.setAttribute('aria-disabled', true);
    this.buttonMinus.disabled = true;
    if (this.submitButton) {
      this.submitButton.removeAttribute("aria-disabled");
    }

    if (this.addToCartButton) {
      this.addToCartButton.resetState();
    }
    
    try {
      const data = await this.updateCartQuantity(requestedQuantity);
      if (!data) {
        throw new Error();
      }

      const cartItem = data.items.find(item => item.key === this.cartItemKey);

      if (cartItem && (requestedQuantity !== cartItem.quantity && requestedQuantity >= cartItem.quantity)) {
        this.buttonPlus.setAttribute('aria-disabled', true);
        this.errorCartItemKey = this.cartItemKey;

        throw new Error(this.saveErrorToStorage());
      } else {
        this.errorCartItemKey = null;
        this.clearError();
      }

      if (this.cartMiniContainer) {
        this.checkoutButton = this.cartMiniContainer.querySelector('.cart-mini-checkout-button');
        this.setLoadingState(true);
        this.buttonPlus.setAttribute('aria-disabled', true);
        this.buttonPlus.disabled = true;
        this.buttonMinus.setAttribute('aria-disabled', true);
        this.buttonMinus.disabled = true;
      }
    } catch (error) {
      this.showError(error.message);
      this.setLoadingState(false);
      this.buttonPlus.setAttribute('aria-disabled', false);
      this.buttonPlus.disabled = false;
      this.buttonMinus.setAttribute('aria-disabled', false);
      this.buttonMinus.disabled = false;
    } finally {
      await this.cartMini.refresh();
      this.buttonPlus.setAttribute('aria-disabled', false);
      this.buttonPlus.disabled = false;
      this.buttonMinus.setAttribute('aria-disabled', false);
      this.buttonMinus.disabled = false;

      if (this.errorCartItemKey === this.cartItemKey) {
        this.buttonPlus.setAttribute('aria-disabled', true);
        this.buttonPlus.disabled = true;
      }
    }
  }

  async updateCartQuantity(quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: this.cartItemKey,
        quantity
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();

      throw new Error((errorData.description || errorData.message));
    }
    
    return response.json();
  }

  formatErrorMessage() {
    const variantInfo = this.variantTitle ? ` - ${this.variantTitle}` : '';
    return `${this.productTitle} ${variantInfo} is out of stock.`;
  }

  showError(message) {
    const errorMessage = message || this.formatErrorMessage();
    this.saveErrorToStorage(errorMessage);
    this.displayError(errorMessage);
  }

  displayError(message) {
    const errorTag = document.createElement('div');
    errorTag.classList.add('cart_response_error_message');
    errorTag.innerText = message;
    this.cartItemParent.after(errorTag);
    this.errorTag = errorTag;
  }

  clearError() {
    localStorage.removeItem(this.getStorageKey());
    if (this.errorTag) {
      this.errorTag.remove();
    }
  }

  saveErrorToStorage(message) {
    const errorData = {
      message,
      productTitle: this.productTitle,
      variantTitle: this.variantTitle,
      key: this.cartItemKey
    };
    localStorage.setItem(this.getStorageKey(), JSON.stringify(errorData));
  }

  restoreErrorFromStorage() {
    const errorDataStr = localStorage.getItem(this.getStorageKey());

    if (errorDataStr) {
      try {
        const errorData = JSON.parse(errorDataStr);
        this.productTitle = errorData.productTitle;
        this.variantTitle = errorData.variantTitle;
        this.displayError(errorData.message);
        this.errorCartItemKey = errorData.key;
      } catch (e) {
        console.error('Error parsing stored error data:', e);
        this.clearError();
      }
    }
  }

  getStorageKey() {
    return `cart_error_${this.cartItemKey}`;
  }

  setLoadingState(isLoading) {
    if (this.checkoutButton) {
      this.checkoutButton.setAttribute('data-loading', isLoading);
      this.checkoutButton.disabled = isLoading;
    }
  }

  disconnectedCallback() {
    this.clearError();
    super.disconnectedCallback?.();
  }
}

customElements.define('quantity-cart-mini-input', QuantityCartMiniInput);

class ProductCouponCheckbox extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.input.addEventListener("change", this.onChange.bind(this));
    const buttonId = this.input.getAttribute("data-button-id");
    this.submitButton = document.getElementById(buttonId);
    this.addToCartButton = new AddToCartButton(this.submitButton);
    this.activeCouponLabel = document.querySelector(
      ".product-coupon-active-label"
    );
    this.activeCouponPrice = document.querySelector(
      ".product-coupon-active-price"
    );
    this.init();
  }

  init() {
    const checkboxState = getCookie("coupon_applied");
    if (checkboxState !== "") {
      this.input.checked = checkboxState === "true";
    }

    this.handleAddTextReplaceTagForPrice();
  }

  onChange(event) {
    event.preventDefault();
    const coupon = event.currentTarget.getAttribute("data-coupon");
    if (!coupon) return;

    const setLoadingState = () => {
      this.addToCartButton.setState("loading");
      this.input.disabled = true;
      this.submitButton.setAttribute("aria-disabled", true);
    };

    const removeLoadingState = () => {
      this.input.disabled = false;
      this.addToCartButton.setState("default");
      this.submitButton.setAttribute("aria-disabled", false);
      window.miniCartInstance.refresh();
      setCookie("coupon_applied", this.input.checked, 1);

      this.handleAddTextReplaceTagForPrice();
    };

    if (event.currentTarget.checked) {
      setLoadingState();
      $.ajax({
        url: "/discount/" + coupon,
        success: removeLoadingState.bind(this),
        error: removeLoadingState.bind(this),
      });
    } else {
      setLoadingState();
      $.ajax({
        url: "/discount/remove",
        success: removeLoadingState.bind(this),
        error: removeLoadingState.bind(this),
      });
    }
  }

  handleAddTextReplaceTagForPrice() {
    if (this.input.checked) {
      if (!this.activeCouponLabel) return;
      this.activeCouponLabel.classList.remove("hidden");
      if (!this.activeCouponPrice) return;
      if (!this.activeCouponPrice.innerHTML.includes("<s>")) {
        this.activeCouponPrice.innerHTML = `<s>${this.activeCouponPrice.textContent}</s>`;
      }
    } else {
      if (!this.activeCouponLabel) return;
      this.activeCouponLabel.classList.add("hidden");
      if (!this.activeCouponPrice) return;
      this.activeCouponPrice.innerHTML = this.activeCouponPrice.textContent;
    }
  }
}

customElements.define("product-coupon-checkbox", ProductCouponCheckbox);
